import "../../styles/all.css"
import "../../styles/theme.css"
import "./email.css"
import Sidebar from "../sidebar/side"
function Email(){
    return(
        <>
        <Sidebar/>
        <div className="email">
            <div className="start">
                <h4>Email  Reports</h4>
               <button>View Alls</button>
            </div>

            <div class="container my-5">
  <div class="row g-4">
        <div class="col-12 col-md-6 col-lg-4 col-xl-3">
      <div class="card  text-center h-100">
        <div class="card-body py-5">
          <i class="fas fa-envelope text-primary fa-4x mb-4"></i>
          <h3 class="fw-bold ">50,545</h3>
          <h4 class=" fs-5">Total Emails</h4>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4 col-xl-3">
      <div class="card  border-0 text-center h-100">
        <div class="card-body py-5">
          <i class="fas fa-users text-success fa-4x mb-4"></i>
          <h3 class="fw-bold ">12,984</h3>
          <h4 class=" fs-5">Total Users</h4>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4 col-xl-3">
      <div class="card  text-center h-100">
        <div class="card-body py-5">
          <i class="fas fa-shopping-cart text-purple fa-4x mb-4"></i>
          <h3 class="fw-bold ">8,742</h3>
          <h4 class=" fs-5">Total Orders</h4>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4 col-xl-3">
      <div class="card  text-center h-100">
        <div class="card-body py-5">
          <i class="fas fa-dollar-sign text-warning fa-4x mb-4"></i>
          <h3 class="fw-bold ">$284,950</h3>
          <h4 class=" fs-5">Total Revenue</h4>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4 col-xl-3">
      <div class="card  text-center h-100">
        <div class="card-body py-5">
          <i class="fas fa-chart-line text-info fa-4x mb-4"></i>
          <h3 class="fw-bold ">63.8%</h3>
          <h4 class=" fs-5">Conversion Rate</h4>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4 col-xl-3">
      <div class="card  text-center h-100">
        <div class="card-body py-5">
          <i class="fas fa-clock text-orange fa-4x mb-4"></i>
          <h3 class="fw-bold ">1,420</h3>
          <h4 class=" fs-5">Pending Tasks</h4>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4 col-xl-3">
      <div class="card  text-center h-100">
        <div class="card-body py-5">
          <i class="fas fa-headset text-danger fa-4x mb-4"></i>
          <h3 class="fw-bold ">3,219</h3>
          <h4 class=" fs-5">Support Tickets</h4>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4 col-xl-3">
      <div class="card  text-center h-100">
        <div class="card-body py-5">
          <i class="fas fa-box-open text-teal fa-4x mb-4"></i>
          <h3 class="fw-bold ">947</h3>
          <h4 class=" fs-5">New Products</h4>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4 col-xl-3">
      <div class="card  text-center h-100">
        <div class="card-body py-5">
          <i class="fas fa-chart-pie text-pink fa-4x mb-4"></i>
          <h3 class="fw-bold ">42.3K</h3>
          <h4 class=" fs-5">Page Views</h4>
        </div>
      </div>
    </div>

  </div>
</div>
        </div>
        </>
    )
}
export default Email